import React, { useEffect, useState } from 'react';
import { CKEditor, } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


interface CKEditorComponentProps {
    initialValue: string;
    editorValueRef?: (setter: React.Dispatch<React.SetStateAction<string>>) => void;
    onChange?: (data: string) => void;
    onBlur?: () => void;
}

const CKEditorField: React.FC<CKEditorComponentProps> = React.memo(
    ({ initialValue, editorValueRef, onChange = () => { } }) => {
        const [editorValue, setEditorValue] = useState(initialValue);

        useEffect(() => {
            setEditorValue(initialValue);
            editorValueRef && editorValueRef(setEditorValue);
        }, [initialValue]);

        const handleEditorChange = (event: any, editor: any) => {
            console.log({ event, editor });
            const data = editor.getData();
            onChange(data);
        };

        return (
            <CKEditor
                editor={ClassicEditor as unknown as any}
                data={editorValue}
                onChange={handleEditorChange}
                config={{
                    toolbar: {
                        items: [
                            'heading',
                            '|',
                            'bold',
                            'italic',
                            'link',
                            'bulletedList',
                            'numberedList',
                            '|',
                            'indent',
                            'outdent',
                            '|',
                            'imageUpload',
                            'blockQuote',
                            'insertTable',
                            'mediaEmbed',
                            'undo',
                            'redo',
                            'fontColor',
                            'fontSize',
                            'fontFamily',
                            'MathType',
                            'ChemType',
                            'alignment'
                        ]
                    },
                    language: 'en',
                }}
            />
        );
    }
);

CKEditorField.displayName = 'CKEditorField';

export default CKEditorField;
